import { apiClient } from './apiClient'
import { apiClientAddresses } from './apiClientAddresses'
import { apiClientDetails } from './apiClientDetails'
import { apiClientLotalty } from './apiClientLotalty'
import { apiClientMessages } from './apiClientMessages'
import { apiClientRankings } from './apiClientRankings'
import { apiClientRatings } from './apiClientRatings'
import { apiClientTeams } from './apiClientTeams'
import { apiClientWallets } from './apiClientWallets'
import { apiNewsletter } from './apiNewsletter'

const apiClients = {
	...apiClient,
	...apiClientTeams,
	...apiClientAddresses,
	...apiClientMessages,
	...apiClientRatings,
	...apiClientRankings,
	...apiClientWallets,
	...apiClientLotalty,
	...apiClientDetails,
	...apiNewsletter,
}

export { apiClients }
